<template>
    <div  class="col-lg-3 col-md-4 col-6 top-catalog-card" @mouseover="isMouseOver=true" @mouseout="isMouseOver=false">
      <div class="border p-md-5 p-2 position-relative">
        <div class="mt-md-3 ">
          <a :href="'/catalog/list/' + category.category.catalog_code" class="top-catalog-header">{{ category.category.name }}</a>
        </div>

        <div  :class="'top-category-list w-75-100 b-4 ' + (isMouseOver && 'd-none')"  >
          <div class="d-flex justify-content-md-between justify-content-center top-catalog-images">
            <div >
              <a :href="'/catalog/list/' + category.category.catalog_code" class="top-catalog-header">
                <img class="main"  :src="'/catalog/icons' + brandPostfix  + '/' + category.category.catalog_code + '.svg'" alt="" />
              </a>
            </div>
            <div class="text-right mt-4 pt-4 d-none d-lg-block" ><img height="60" src="/images/thorvik/plus.svg"  alt=""></div>
          </div>
        </div>
        <div :class="'top-category-list  '  + (!isMouseOver && ' d-none')">
          <ul class="list-unstyled mt-3">
            <li v-for="(scategory, index) in category.items" :key="scategory.id"><a  v-if="index < maxVisible || showFull" :href="'/catalog/list/' + scategory.catalog_code + '/' + scategory.human_url">{{ scategory.name }}</a></li>
          </ul>
          <div  v-if="category.items.length > maxVisible"><a class="more-category" href="javascript:void(0);" @click="showFull=true" v-if="showFull==false">еще {{ category.items.length - maxVisible }} категорий</a></div>
          <div  v-if="category.items.length > maxVisible"><a class="more-category"  href="javascript:void(0);" @click="showFull=false" v-if="showFull==true">скрыть {{ category.items.length - maxVisible }} категорий</a></div>
          <div class="mt-3">
            <a
                :href="'/catalog/list/' + category.category.catalog_code + '/' + category.category.human_url"
                class="go-to-product"
            >Перейти к продуктам</a>
          </div>

        </div>

      </div>
    </div>


</template>

<script>
    export default {
        name: 'TopCatalogItem',
        props: ['category'],
        data() {
            return {
                showFull: false,
                maxVisible: 5,
                isMouseOver: false
            }
        },
        computed: {
            brandPostfix(){
                return window.postfix
            }
        }
    }
</script>